import React, { useEffect } from "react";
import { useSendAnalyticsEvent } from "../../analytics/events";
import { useAuth } from "../../auth/useAuth";
import { useSpaceInfo } from "../../liveblocks/maps";

export default function SpaceCreationLoader({
  children,
}: {
  children: React.ReactNode;
}) {
  const sendAnalyticsEvent = useSendAnalyticsEvent();
  const [spaceInfo, spaceInfoClient] = useSpaceInfo();
  const hasOwner = spaceInfo?.owners && spaceInfo.owners.length > 0;
  const { user } = useAuth();

  useEffect(() => {
    if (spaceInfo && !hasOwner && user) {
      sendAnalyticsEvent({ name: "spaceCreated" });
      spaceInfoClient?.set("owners", [user.id]);
    }
  }, [spaceInfo, hasOwner, user, sendAnalyticsEvent, spaceInfoClient]);

  return <>{children}</>;
}
